import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function AudienceSection() {
  const audience = [{
    icon: '👩‍👧',
    type: 'Madre',
    pain: 'Agotada de dar sin recibir, sin un momento genuinamente tuyo'
  }, {
    icon: '👩‍💼',
    type: 'Profesional',
    pain: 'Llevas el estrés del trabajo a casa y no puedes "apagar" el modo ejecutiva'
  }, {
    icon: '💑',
    type: 'En pareja',
    pain: 'Absorbes las emociones de los demás y al final del día no queda nada para ti'
  }, {
    icon: '🎓',
    type: 'Estudiante',
    pain: 'La presión académica y la ansiedad por el futuro no te dejan dormir'
  }, {
    icon: '🌀',
    type: 'En transición',
    pain: 'Cambio de trabajo, separación, mudanza — tu sistema nervioso no encuentra el suelo'
  }, {
    icon: '💆',
    type: 'Simplemente agotada',
    pain: 'No hay una razón "suficientemente grande" — solo el peso acumulado de vivir siempre en alerta'
  }];
  return <section className="px-6 py-10 max-w-4xl mx-auto" data-id="element-1">
      <FadeIn data-id="element-2">
        <div className="text-center mb-8" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4A5D3A] inline-block border-b-2 border-[#C4A265] pb-2" data-id="element-4">
            ESTO ES PARA TI SI ERES:
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5">
          {audience.map((item, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-sm border border-[#4A5D3A]/10 flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-6">
              <div className="text-4xl shrink-0" data-id="element-7">{item.icon}</div>
              <div data-id="element-8">
                <h3 className="font-bold text-xl text-[#2D2A26] mb-2" data-id="element-9">
                  {item.type}
                </h3>
                <p className="text-[#2D2A26]/80 leading-relaxed" data-id="element-10">{item.pain}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-10 text-center space-y-3 bg-[#9B4F2B]/5 p-6 rounded-2xl border border-[#9B4F2B]/20" data-id="element-11">
          <p className="text-xl md:text-2xl font-bold text-[#2D2A26]" data-id="element-12">
            No importa tu edad. No importa tu situación.
          </p>
          <p className="text-2xl md:text-3xl font-serif font-bold text-[#9B4F2B]" data-id="element-13">
            Si tu mente no puede soltar cuando tu cuerpo necesita descansar —
            esto es para ti.
          </p>
        </div>
      </FadeIn>
    </section>;
}